module.exports = __webpack_public_path__ + "img/submit.6984f4d6.png";